import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const GlobalNicCodesBasicInfoComponent = ({ nicCode, handleInnerBasicFormChange }: any) => {

  return (<>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Name"
            onValueChange={(event: any, newValue: any) => {
              handleInnerBasicFormChange(
                event.target.value,
                'Name',
              );
            }}
            type="text"
            value={nicCode?.Name}
          />
          <InputContainer
            label="Global NICCode"
            onValueChange={(event: any, newValue: any) => {
              handleInnerBasicFormChange(
                event.target.value,
                'GlobalNICCode',
              );
            }}
            type="text"
            value={nicCode?.GlobalNICCode}
          />
        </div>

      }
      expandedPanel="basicInfo"
      headerTitle="Basic Info"
    />
  </>
  )
}
export default GlobalNicCodesBasicInfoComponent;
